<template>
  <div v-if="showLoading" class="ml-2">
    <div class="spinner-local"></div>
  </div>
</template>

<script>
import { useLoadingSpinnerStore } from '@/stores/loadingSpinner.ts';
export default {
  setup() {
    const loadingSpinnerStore = useLoadingSpinnerStore();
    return { loadingSpinnerStore };
  },
  data() {
    return {
      showLoading: false,
      showTransition: false,
    };
  },
  watch: {
    'loadingSpinnerStore.localLoadingSpinner': function () {
      const self = this;
      if (this.loadingSpinnerStore.localLoadingSpinner) {
        self.showLoading = true;
        self.showTransition = true;
      } else {
        self.showTransition = false;
        setTimeout(() => {
          self.showLoading = false;
        }, 200);
      }
    },
  },
};
</script>
<style>
.spinner-local {
  height: 22px;
  width: 22px;
  animation: rotateSpinner 0.8s infinite linear;
  border: 2px solid white;
  border-right-color: transparent;
  border-radius: 50%;
}

@keyframes rotateSpinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
